/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Deadline_Due_TodayInputs */

const en_task_deadline_due_today = /** @type {(inputs: Task_Deadline_Due_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due today`)
};

const pt_br2_task_deadline_due_today = /** @type {(inputs: Task_Deadline_Due_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vence hoje`)
};

/**
* | output |
* | --- |
* | "Due today" |
*
* @param {Task_Deadline_Due_TodayInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_deadline_due_today = /** @type {((inputs?: Task_Deadline_Due_TodayInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Deadline_Due_TodayInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_deadline_due_today(inputs)
	return pt_br2_task_deadline_due_today(inputs)
});